export default "__VITE_ASSET__0cfd22bb__"